export default __webpack_public_path__ + "static/media/007-autonomous car.a53b2a87.svg";